import capitalizeFirstLetter from '@utilities/functions/capitalizeFirstLetter'

const transformSlugToCategory = (slug: string) => {
  return slug.split('-').map(capitalizeFirstLetter).join(' ')
}

export default transformSlugToCategory
